export default {
  title: 'Renseignements personnels',
  warningLabel: 'Veuillez noter',
  successLabel: 'Vos changements seront effectifs d\'ici 48 heures pour ces contrats :',
  successLabelNoContracts: 'Vos changements seront effectifs d\'ici 48 heures.',
  closeButton: 'Retour',
};
